Contact = {
	init : ->
		console.log 'Contact init'
		#@confirmManager()

	confirmManager : ->

		$('.contact--form').on "submit", (ev) ->
			ev.preventDefault()
			tl = new TimelineLite()
			tl.to $('.contact--send'), 0.4, {autoAlpha:0, x:20, ease:Quint.easeOut}
				.fromTo $('.contact--confirm'), 0.4, {autoAlpha:0, x:-20}, {autoAlpha:1, x:0, ease:Quint.easeOut}
			# params = $(@).serialize()
			# data = 'action=send_message&' + params
			# $.ajax {
			# 	type:'POST',
			# 	data: data,
			# 	success: (results) ->
					
			# 		results = JSON.parse results

			# 		if results.valid
			# 			tl = new TimelineLite()
			# 			tl.to $('.contact--send'), 0.4, {autoAlpha:0, x:20, ease:Quint.easeOut}
			# 				.fromTo $('.contact--confirm'), 0.4, {autoAlpha:0, x:-20}, {autoAlpha:1, x:0, ease:Quint.easeOut}
			# 		else 
			# 			$('.alerts-container').html('')
			# 			$('.alerts-container').append(results.alert)
			# 			App.alerteManager()

			# }
	destroy : ->
		console.log 'Contact destroy'
}